import { Component, Input, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AjaxService } from 'src/app/services/ajax.service';
import { CommonService } from 'src/app/services/common.service';
import { companyReportData, serverUrl, storageVariable } from 'src/environments/environment';

@Component({
  selector: 'app-recurrence',
  templateUrl: './recurrence.component.html',
  styleUrls: ['./recurrence.component.scss'],
})
export class RecurrenceComponent implements OnInit {
  @Input() recurrencedata
  constructor(
    private commonServices: CommonService,
    private ajaxService: AjaxService,
    private alertController: AlertController,
    private trans: TranslateService,



  ) {
  }
  ngOnChanges(data) {
    this.commonServices.dismissLoader()
    this.recurrencedata = companyReportData.recurrenceData
  }

  async deleteRecurrenceData(data) {
    const alert = await this.alertController.create({
      header: this.trans.instant('Are you sure?'),
      backdropDismiss: false,
      message: this.trans.instant("You want to delete!"),
      buttons: [{
        text: this.trans.instant('Cancel'),
        role: 'cancel',
        handler: data1 => {

        }
      },
      {
        text: this.trans.instant('Ok'),
        handler: data1 => {
          this.deleteRecurrenceDataConfirm(data);
        }
      }]
    });
    await alert.present();

  }

  deleteRecurrenceDataConfirm(data) {
    this.commonServices.presentLoader();
    var multidlt = {};
    multidlt["companyId"] = localStorage.corpId;
    multidlt["branchId"] = localStorage.corpId;
    multidlt["userId"] = localStorage.userName;
    multidlt["id"] = data.id + ",";
    var jsondetails = JSON.stringify(multidlt);
    let url = serverUrl.web + "/ReportController/deletrecurrencedata/" + jsondetails;
    this.ajaxService.ajaxGetJson(url)
      .subscribe(res => {
        this.commonServices.presentToast("Deleted successfully")
        this.getrecurrencedata();
      })
  }
  startRecurrence(data) {
    this.commonServices.presentLoader();
    if (data.status == "Active") {
      this.commonServices.dismissLoader();
      this.commonServices.presentToast("Already Started")
      return;
    }

    var multidlt = {};
    multidlt["companyId"] = localStorage.corpId;
    multidlt["branchId"] = localStorage.corpId;
    multidlt["userId"] = localStorage.userName;
    multidlt["start"] = "start";
    multidlt["id"] = data.id + ",";
    var jsondetails = JSON.stringify(multidlt);
    let url = serverUrl.web + "/ReportController/stoprecurrence/" + jsondetails;
    this.ajaxService.ajaxGetJson(url)
      .subscribe(res => {
        this.commonServices.presentToast("Started successfully")
        this.getrecurrencedata();
      })



  }
  stopRecurrence(data) {
    this.commonServices.presentLoader();
    if (data.status == "Inactive") {
      this.commonServices.dismissLoader();
      this.commonServices.presentToast("Already Stopped")
      return;
    }

    var multidlt = {};
    multidlt["companyId"] = localStorage.corpId;
    multidlt["branchId"] = localStorage.corpId;
    multidlt["userId"] = localStorage.userName;
    multidlt["id"] = data.id + ",";
    var jsondetails = JSON.stringify(multidlt);
    let url = serverUrl.web + "/ReportController/stoprecurrence/" + jsondetails;
    this.ajaxService.ajaxGetJson(url)
      .subscribe(res => {
        this.commonServices.presentToast("Stoped successfully")
        this.getrecurrencedata();
      })
  }

  getrecurrencedata() {
    var logindata = {};
    logindata["companyID"] = localStorage.corpId;
    logindata["branchID"] = localStorage.corpId;
    logindata["userID"] = localStorage.userName;
    var jsondetails = JSON.stringify(logindata);
    const url = serverUrl.web + "/ReportController/getRecurrencedata/" + jsondetails;
    this.ajaxService.ajaxGetObject(url)
      .subscribe(res => {
        companyReportData.recurrenceData = JSON.parse(res)
        companyReportData.recurrenceData.map(re => {
          var plateNodata = ""
          re.plateno.split(",").map(de => {
            plateNodata += storageVariable.dashboardData.liveDatas[de].plateNo + ","
          })
          re["plateNoCon"] = plateNodata
        })
        this.recurrencedata = companyReportData.recurrenceData;
        this.commonServices.dismissLoader();
      });
  }

  ngOnInit() {

  }
}
